export const validateExternalId = (id: string, prefix?: string): boolean => {
    const validationRules: Array<(text: string) => boolean> = [
        text => text.startsWith('.'),
        text => text.startsWith('-'),
        text => !(/^[a-z0-9.-]*$/.test(text)),
        text => text.endsWith('..'),
        text => text.endsWith('-.'),
        text => text.endsWith('.-'),
        text => text.endsWith('--'),
    ];

    if (prefix) {
        validationRules.push(text => text.length < prefix.length && !prefix.startsWith(text));
    }

    const invalid = validationRules.some(rule => rule(id));

    return !invalid;
};
